import React, { useEffect } from "react";
import BackButton from "../components/BackButton";

const s = {
  wrapper: { minHeight: "100svh", background: "#f3f4f6", padding: "16px 16px 40px", boxSizing: "border-box", fontFamily: "system-ui, -apple-system, sans-serif" },
  inner: { maxWidth: "680px", margin: "0 auto" },
  card: { background: "white", borderRadius: "16px", boxShadow: "0 4px 24px rgba(0,0,0,0.07)", border: "1px solid #f1f5f9", padding: "24px 20px" },
  h1: { fontSize: "22px", fontWeight: 800, color: "#1e293b", margin: "0 0 4px" },
  tagline: { fontSize: "13px", color: "#64748b", fontStyle: "italic", margin: "0 0 20px" },
  h2: { fontSize: "14px", fontWeight: 700, color: "#1e293b", marginTop: "20px", marginBottom: "6px" },
  p: { fontSize: "14px", color: "#475569", lineHeight: 1.7, margin: "0 0 4px" },
  ul: { fontSize: "14px", color: "#475569", lineHeight: 1.7, paddingLeft: "20px", margin: "4px 0 4px" },
  a: { color: "#2563eb" },
};

const MentionsPage = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div style={s.wrapper}>
      <div style={s.inner}>
        <BackButton fallback="/" />
        <div style={s.card}>
          <h1 style={s.h1}>⚖️ Conditions Générales d'Utilisation (CGU)</h1>
          <p style={s.tagline}>Marque CrushNow® déposée INPI n° 5152773. Dernière mise à jour : mai 2026.</p>

          <h2 style={s.h2}>Article 1 – Objet</h2>
          <p style={s.p}>Les présentes CGU encadrent l'utilisation de l'application CrushNow®. En accédant à l'application, l'utilisateur reconnaît avoir lu et accepté les conditions ci-après.</p>

          <h2 style={s.h2}>Article 2 – Accès et âge minimum</h2>
          <p style={s.p}>L'accès à CrushNow® est gratuit. L'application est destinée aux personnes âgées de <strong>13 ans minimum</strong>. En dessous de cet âge, le consentement d'un parent ou tuteur légal est requis conformément au RGPD.</p>

          <h2 style={s.h2}>Article 3 – Description du service</h2>
          <p style={s.p}>L'application propose notamment :</p>
          <ul style={s.ul}>
            <li>Scan de QR codes et codes-barres produits</li>
            <li>Consultation d'un historique de scans personnels</li>
            <li>Notifications push (optionnelles)</li>
            <li>Carte de localisation des scans (si géolocalisation autorisée)</li>
            <li>Outils de gestion produits pour les vendeurs</li>
            <li>Traçabilité point de vente via géolocalisation</li>
            <li>Partage public d'un produit via URL unique</li>
            <li>Sélection de magasins favoris pour filtrer les notifications</li>
            <li>Renseignement optionnel de données démographiques (genre, tranche d'âge) dans le profil</li>
          </ul>

          <h2 style={s.h2}>Article 4 – Création de compte</h2>
          <p style={s.p}>Deux modes d'inscription sont disponibles :</p>
          <ul style={s.ul}>
            <li><strong>Avec email</strong> : email + mot de passe. Récupération par email.</li>
            <li><strong>Sans email</strong> : pseudonyme + mot de passe + phrase de récupération de 12 mots générée à l'inscription. Cette phrase est affichée <strong>une seule fois</strong> et ne peut pas être récupérée par CrushNow® en cas de perte. L'utilisateur est seul responsable de sa conservation.</li>
          </ul>

          <h2 style={s.h2}>Article 5 – Données scannées et magasins</h2>
          <p style={s.p}>Les données de scan (code-barres, localisation GPS, nom du commerce) sont collectées pour enrichir l'historique personnel de l'utilisateur et, dans le cas des vendeurs inscrits, alimenter leurs statistiques. Ces données appartiennent à CrushNow® et ne sont pas partagées avec les enseignes concernées sans leur consentement explicite.</p>

          <h2 style={s.h2}>Article 6 – Obligations des utilisateurs</h2>
          <ul style={s.ul}>
            <li>Ne fournir que des informations exactes</li>
            <li>Ne pas nuire au fonctionnement du service</li>
            <li>Ne pas détourner l'application de son usage</li>
            <li>Ne pas usurper l'identité d'un magasin ou d'un vendeur</li>
          </ul>

          <h2 style={s.h2}>Article 7 – Données personnelles</h2>
          <p style={s.p}>Voir la <a href="/privacy" style={s.a}>Politique de Confidentialité</a>.</p>

          <h2 style={s.h2}>Article 8 – Propriété intellectuelle</h2>
          <p style={s.p}>CrushNow®, son logo et l'ensemble des éléments visuels et techniques sont protégés par le Code de la propriété intellectuelle. Marque déposée INPI n° 5152773.</p>

          <h2 style={s.h2}>Article 9 – Limitation de responsabilité</h2>
          <ul style={s.ul}>
            <li>CrushNow® ne peut être tenu responsable des contenus publiés par les vendeurs</li>
            <li>Ni des interruptions dues à des services tiers (Railway, Firebase, MongoDB)</li>
            <li>Ni de la perte d'accès au compte en cas de perte de la phrase de récupération</li>
          </ul>

          <h2 style={s.h2}>Article 10 – Modifications</h2>
          <p style={s.p}>Les présentes CGU peuvent être modifiées à tout moment. Une notification est envoyée aux utilisateurs en cas de changement majeur.</p>

          <h2 style={s.h2}>Article 11 – Droit applicable</h2>
          <p style={s.p}>Les présentes CGU sont soumises au droit français. Tout litige relève de la compétence des tribunaux français.</p>
        </div>
      </div>
    </div>
  );
};

export default MentionsPage;
